export default __webpack_public_path__ + "static/media/3_long.f8e86e67.svg";